module.exports = __webpack_public_path__ + "9788f41e/img/boston-lights.a623432f.png";